import { createApp, configureCompat } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import network from './constant.js'
import axios from './axios.js'
import utils from './utils'
import 'core-js'

// 抑制已知的遷移警告
configureCompat({
  COMPONENT_ASYNC: 'suppress-warning',
  RENDER_FUNCTION: 'suppress-warning',
  WATCH_ARRAY: 'suppress-warning'
})

const app = createApp(App)
app.use(store)
app.use(router)

// 註冊 axios plugin
app.use(axios)

app.config.globalProperties.$network = network
app.config.globalProperties.$utils = utils

app.mount('#app')
